import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {  map, startWith } from 'rxjs/operators';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../../../retailer.service';

@Component({
  templateUrl: './linked-retailer.component.html',
  styleUrls: ['../edit-retailer.component.scss']
})
export class LinkedRetailerComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {

  @ViewChild('linkedAccountInput') linkedAccountInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  allLinkableRetailers: any;
  currentLinkedRetailers: any;
  linkedAccountCtrl = new FormControl();
  filteredlinkedAccounts: Observable<any>;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  visible = true;
  selectable = true;
  removable = true;
  retailerId: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private retailerService: RetailerService) {
    super();
   
    this.allLinkableRetailers = data.allLinkableRetailers;
    this.currentLinkedRetailers = data.currentLinkedRetailers;
    this.retailerId = data.retailerId;
  }



  remove(item: any): void {
   
    const index = this.currentLinkedRetailers.indexOf(item);

    if (index >= 0) {
      this.currentLinkedRetailers.splice(index, 1);
      this.allLinkableRetailers.push(item)
      //API call
      this.retailerService.UnLinkRetailerAccount(item.retailerLinkedAccountId).subscribe(res => {
        if (res && res) { 
          if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_111") || res.responseStatus == 'Success'){
        }
        }
      });
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
     //;
     //return;
    if (this.currentLinkedRetailers.filter(x => x.businessName.indexOf(event.option.value.businessName) === 0).length === 0){

      //API call 
      let formData:any = {
        "childRetailerId": event.option.value.childRetailerId,
        "parentRetailerId":this.retailerId
      }
      this.retailerService.linkRetailerAccounts(formData).subscribe(res => {
        if (res && res) { 
          if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_111") || res.responseStatus == 'Success'){
            this.retailerService.getRetailersLinkedById(this.retailerId).subscribe(
              res => {
                if(res['httpcode'] == 200){
                  this.currentLinkedRetailers =res['data']
                    
                }
              }
            )
        }
        }
      });

      



    }
    this.linkedAccountInput.nativeElement.value = '';
    this.linkedAccountCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
   
    const filterValue = value.toLowerCase();

    return this.allLinkableRetailers.filter(item => item.businessName.toLowerCase().includes(filterValue));
  }

  ngOnInit(): void {
    super.ngOnInit()
    this.linkedAccountCtrl.valueChanges.subscribe(res => {
      if (res && res) {
        let account: string;
        account = res.businessName ? res.businessName : res;
        this.filteredlinkedAccounts = account ? this._filter(account) : this.allLinkableRetailers.slice();
      }
    })
  }

  ngOnDestroy(): void {
    super.ngOnDestroy()
  }

}
